<div class="header" >
  <div class="content" [ngsRevealSet]="{ reset:false, scale:1, distance: '20px'}" [ngsInterval]="50" [ngsSelector]="'.pageTitle'">
    <div class="contentInner">
      <div class="pageTitle">
        <h1 class="headline">Contact us</h1>
      </div>
    </div>
  </div>
</div>
<div class="content">

  <div class="form">
    <div class="successMessage" [ngClass]="{'shown': hasSubmitted()}"><div class="tickImage"></div><div class="msg">Your message has been sent!</div></div>
    <div class="errorMessage" [ngClass]="{'shown': hasError()}"><div class="crossImage"></div><div class="msg">There was a problem sending your message.  Please contact <a href="mailto:support@get-dash.com">support@get-dash.com</a></div></div>
    <div class="formContent" [ngClass]="{'hidden': hasSubmitted() || hasError()}">
      <p class="intro">Have a question you can't find the answer to in the <a routerLink="/guide">guide</a> section?  Want to know more about our plans and pricing?  Drop us a line!</p>
      <p class="error" *ngIf="errorMessage !== null" [innerHTML]="errorMessage"></p>
      <p>Name</p>
      <input #name type="text" id="name" name="name">
      <p>Email</p>
      <input #email type="text" id="email" name="email">
      <p>How can we help?</p>
      <textarea #message id="message" name="message" rows="10" cols="33"></textarea>
      <a class="button" (keypress)="submit(name.value, email.value, message.value)" tabindex="0" (click)="submit(name.value, email.value, message.value)"><div *ngIf="isSubmitting()" class="spinner"></div><span *ngIf="!isSubmitting()">Send</span></a>
    </div>
  </div>

</div>
